/**
 * 告诉后端「这是哪个客户端、哪个版本」：`X-Client: nova-web/<版本>+<构建号>`。
 *
 * 后端据此统计旧 AI 接口还有谁在调（main-api AI 调用迁移计划 P0，`GET /platform/ai/legacy-usage`），
 * 某个旧接口在观察期内没人调才删它。只加在发往本仓 API 的请求上——发往别的域（S3 预签名上传等）的请求
 * 多一个自定义头会触发 CORS 预检，甚至让签名对不上。
 */
export const X_CLIENT = `nova-web/${__APP_VERSION__}+${__BUILD_NUMBER__}`

/** 相对路径，或以 API 基址开头的绝对地址 = 发往本仓 API。 */
export function isOwnApiRequest(url: string | undefined, baseURL: string | undefined, apiBase: string): boolean {
  const target = url ?? ''
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(target)) return !!apiBase && target.startsWith(apiBase)
  const base = baseURL ?? ''
  return !base || (!!apiBase && base.startsWith(apiBase))
}
